import validatesFile from 'helpers/validates/file'

import toFileList from './toFileList'

// Contexto fora do FileUploadInput
const filterAccepted = (event, attachments, accept = '') => {
  const files = event.target.files
  const currentFiles = attachments ? Array.from(attachments) : []

  const newFiles =
    Array.from(files).filter(
      (newFile) =>
        !validatesFile.isFileInList(newFile, currentFiles) &&
        validatesFile.isFileAccepted(newFile, accept),
    ) || []

  return toFileList([...currentFiles, ...newFiles])
}

export default filterAccepted
